import React, { useEffect } from 'react'

import Tooltip2 from 'components/common/Tooltip2.0'
import { microphoneEventEmitter, microphoneKeys } from 'helpers/events'
import useLocalAudioToggle from 'hooks/useLocalAudioToggle/useLocalAudioToggle'
import useSpeakingOnMute from 'hooks/useSpeakingOnMute'

import { Wrapper } from './styles'

const SpeakingOnMute = () => {
    const [isAudioEnabled] = useLocalAudioToggle()

    useEffect(() => {
        const handleSpeakingOnMute = value => {
            const unmuteSpeakToastElement = document.getElementById(
                'unmute-speak-toast'
            )
            if (unmuteSpeakToastElement) {
                if (value) {
                    unmuteSpeakToastElement.style.setProperty('display', 'flex')
                } else {
                    unmuteSpeakToastElement.style.setProperty('display', 'none')
                }
            }
        }

        microphoneEventEmitter.addListener(
            microphoneKeys.SPEAKING_ON_MUTE,
            handleSpeakingOnMute
        )

        return () => {
            microphoneEventEmitter.removeListener(
                microphoneKeys.SPEAKING_ON_MUTE,
                handleSpeakingOnMute
            )
        }
    }, [])

    useSpeakingOnMute(isAudioEnabled)

    return (
        <Wrapper>
            <Tooltip2
                id="unmute-speak-toast"
                content="Oh. unmute to speak"
                placement="right"
            />
        </Wrapper>
    )
}

export { SpeakingOnMute }
